function createLocalDatatable(domElement, options) {
	if (typeof domElement === 'string') {
		domElement = document.querySelector(domElement);
	}

	const defaultOptions = {
		dom: '<"d-flex"<"data-table-filter-input-and-length-selector"f<"ml-4"l>>><rt><ip>',
		initComplete: () => {
			domElement.classList.remove('d-none');
		}
	};

	const finalOptions = {
		...defaultOptions, ...options
	};

	// noinspection JSUnresolvedFunction
	const dataTable = $(domElement).DataTable(finalOptions);

	// Assign datatable class
	domElement.classList.add('data-table-v1');
	dataTable.table().container().classList.add('data-table-v1');

	return dataTable;
}

/**
 * Retrieves and setup datatable components so they can be properly used
 * inside a modal, without unnecessary scroll bars
 *
 * @param dataTable
 */
function getDatatableComponentsForModal(dataTable) {
	const tableContainer = dataTable.table().container();

	/** @var {HTMLElement} */
	const dataTableHeader = tableContainer.children[0];
	dataTableHeader.classList.add('datatable-header');

	/** @var {HTMLElement} */
	const dataTableFooter = tableContainer.querySelector('.dataTables_info').parentElement;
	dataTableFooter.classList.add('datatable-footer');

	return {
		dataTableHeader,
		dataTableFooter
	}
}

export {createLocalDatatable, getDatatableComponentsForModal}
